import { Controller } from "@hotwired/stimulus"

// Slides a toast in, auto-dismisses after `duration`, and pauses while hovered or focused.
export default class extends Controller {
  static values = { duration: { type: Number, default: 5000 } }

  connect() {
    requestAnimationFrame(() => this.element.classList.add("is-visible"))
    this.start()
    this.element.addEventListener("mouseenter", this.stop)
    this.element.addEventListener("mouseleave", this.start)
    this.element.addEventListener("focusin", this.stop)
    this.element.addEventListener("focusout", this.start)
  }

  disconnect() {
    this.stop()
  }

  start = () => {
    this.stop()
    this._timer = setTimeout(() => this.dismiss(), this.durationValue)
  }

  stop = () => clearTimeout(this._timer)

  dismiss() {
    this.stop()
    this.element.classList.remove("is-visible")
    const remove = () => this.element.remove()
    this.element.addEventListener("transitionend", remove, { once: true })
    setTimeout(remove, 400)
  }
}
